import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './popups.module.scss';

function ImagePopup(props) {
  const closePopup = () => {
    props.close(true);
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={closePopup} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className={styles.popupImg}>
          <img src={props.imgUrl} alt={'popupImgUrl'} className="w-100" />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ImagePopup;
